import { IBasket } from "@crunchit/types";
import { defaultBasket } from "./defaults";

export const basketFactory = (basket: Partial<IBasket> | null = {}): IBasket => {
  return {
    ...defaultBasket,
    ...basket,
  };
};
